import { render, staticRenderFns } from "./ChatMergeForward.vue?vue&type=template&id=0b697bb6&scoped=true"
import script from "./ChatMergeForward.vue?vue&type=script&lang=js"
export * from "./ChatMergeForward.vue?vue&type=script&lang=js"
import style0 from "./ChatMergeForward.vue?vue&type=style&index=0&id=0b697bb6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../box-im/im-web/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b697bb6",
  null
  
)

export default component.exports